<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3">
        <div class="card card-bottom-radius-8" style="background-color: #f9f9f9;">
          <div class="card-block">
            <div class="form-group row">
              <div class="col-md-12 text-center pt-3">
                <h3>SOLICITAR AUTORIZAÇÃO PARA DESPESAS DIVERSOS</h3>
              </div>
            </div>
            <div class="form-group row pt-3">
              <div class="col-md-4 pl-5">
                <label for="cbxInsure"><small class="text-danger">*</small> Obra:</label>
                <autocomplete-z ref="obraRHTypeahead"
                                placeholder="Digite o nome da Obra"
                                iconClass="fas fa-hard-hat"
                                :serializer="(obra) => obra.referencia"
                                :debounceLength="2"
                                :formField="form.obraID"
                                v-on:search="onSearchObra"
                                v-on:changeCode="onChangeCodeObra"/>
              </div>
              <div class="col-md-4">
                <label for="txtInsured"><small class="text-danger">*</small> Responsável:</label>
                <autocomplete-z ref="responsavelTypeahead"
                                placeholder="Digite o nome do Responsável"
                                iconClass="fas fa-users"
                                :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                                :debounceLength="3"
                                :formField="form.responsavelID"
                                v-on:search="onSearchResponsavel"
                                v-on:changeCode="onChangeCodeResponsavel" />
              </div>
              <div class="col-md-4 pr-5">
                <label for="cbxInsure"><small class="text-danger">*</small> Regional:</label>
                <div class="input-group">
                  <b-form-input type="text"
                                class="col-2 text-upper"
                                style="height: calc(2.09375rem + 2px);"
                                :placeholder="'Código'"
                                v-model="form.secaoRH.value"
                                :size="form.secaoRH.maxlength"
                                :state="form.secaoRH.state"
                                @focus="onClearSection"
                                v-on:change="onChangeCodeSection"
                  />&nbsp;
                  <b-form-select v-model="form.secaoRHID.value"
                                :options="form.secaoRHID.options" >
                    <template slot="first">
                      <!-- this slot appears above the options from 'options' prop -->
                      <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </div>
            <div class="form-group row pt-3">
              <div class="col-md-4 pl-5">
                <label for="txtInsured"><small class="text-danger">*</small> Quem irá receber o Crédito:</label>
                <autocomplete-z ref="favorecidoTypeahead"
                                placeholder="Digite o nome do Funcionário"
                                iconClass="fas fa-hard-hat"
                                :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                                :debounceLength="3"
                                :formField="form.favorecidoID"
                                v-on:search="onSearchFavorecido"
                                v-on:changeCode="onChangeCodeFavorecidoCheckAccount" />
              </div>
              <div class="col-md-4">
                <label><small class="text-danger">*</small> Possui Equipe:</label>
                <div class="input-group">
                  <b-form-select v-model="form.equipe.value"
                                :options="form.equipe.options">
                    <template slot="first">
                      <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                      <option :value="false">{{ $lang.Common.No }}</option>
                      <option :value="true">{{ $lang.Common.Yes }}</option>
                    </template>
                  </b-form-select>
                </div>
              </div>
              <div class="col-md-4 pr-5">
                <label><small class="text-danger">*</small> Valor:</label>
                <div class="input-group">
                  <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
                  <money class="form-control form-control-10 text-right"
                                v-bind="moneyFormat"
                                placeholder="R$ 0,00"
                                prefix="R$ "
                                v-model="form.valorSolicitado.value"
                                :size="form.valorSolicitado.maxlength"
                                :required="form.valorSolicitado.required"
                                :state="form.valorSolicitado.state"/>
                </div>
              </div>
            </div>
            <div class="form-group row pt-3">
              <div class="col-md-12 pl-5 pr-5">
                <label for="txtDescription"> Justificativa:</label>
                <b-form-textarea
                  v-model="form.justificativa.value"
                  :placeholder="''"
                  :rows="form.justificativa.rows"
                  :size="form.justificativa.maxlength"
                  :noResize="form.justificativa.noResize"></b-form-textarea>
              </div>
            </div>
            <div class="form-group row pt-4">
              <div class="col-md-12 text-center">
                <h4>AUTORIZAÇÃO PARA DESCONTO NA FOLHA DE PAGAMENTO</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 pt-3 pl-5 pb-2 pr-5 text-justify">
                <div class="pt-5 pl-5 pb-5 pr-5" style="background-color: #ffffff; border: solid 1px #e1e1e1; border-radius: 5px; max-height: 50px;overflow: auto;">
                  Eu, {{EmployeeName}} com o código {{EmployeeCode}}, funcionário da empresa
                  <strong>Zopone Engenharia e Comércio Ltda</strong>, autorizo a descontar na folha de pagamento, a
                  quantia de R$ {{form.valorSolicitado.value}}, referente à despesa de viagem.
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-left pl-5">
                <b-form-checkbox
                  id="cbxAccept"
                  v-model="form.accept.value"
                  :disabled="form.accept.disabled"
                  name="cbxAccept"
                  value="1"
                  unchecked-value="0"
                >
                  Declaro ter lido o termo acima e aceito todas as suas condições!
                </b-form-checkbox>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-left pt-4 pl-5 pb-4">
                <button ref="confirmTerm" v-if="objTerm == null" type="button" v-bind:disabled="form.accept.value > 0 ? false : true" @click="onConfirmTerm"  class="btn btn-third btn-sm" v-b-tooltip.hover :title="'Clique para aceitar o termo e solicitar a autorização'"><i class="fas fa-user-lock"></i>&nbsp; <span class="d-md-down-none">Solicitar Autorização</span></button>
                <div v-else class="text-left">
                  Situação:
                  <span class="text-danger text-bold">Aguardando autorização!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { JWTService } from '@/shared/services/jwt'
import { loading, toast } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import TermForm from './consentterm-form.js'
import TermData from '@/shared/models/business/acceptterm.js'
import TermType from '@/shared/utils/termtype.js'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import SectionRHRepository from '@/shared/http/repositories/business/sectionrh.js'
import CoordinatorRepository from '@/shared/http/repositories/configuration/coordinator.js'
import ExpenseMixin from '../mixins/ExpenseMixin.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ'

import { mapActions, mapGetters } from 'vuex'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'

export default {
  name: 'ConsentTerm',
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      data: TermData,
      form: TermForm,
      typeTerm: TermType,
      objTerm: null
    }
  },
  components: {
    AutocompleteZ
  },
  computed: {
    ...mapGetters('auth', ['userInfo']),
    staging () {
      return process.env.APIBaseURL !== 'https://api.prod.zopone.com.br'
    },
    EmployeeName () {
      let result = '____________________________________'
      if (this.$refs.favorecidoTypeahead && this.$refs.favorecidoTypeahead.objSelected) {
        result = this.$refs.favorecidoTypeahead.objSelected.nome
      }
      return result
    },
    EmployeeCode () {
      let result = '00000'
      if (this.$refs.favorecidoTypeahead && this.$refs.favorecidoTypeahead.objSelected) {
        result = this.$refs.favorecidoTypeahead.objSelected.codigo
      }
      return result
    }
  },
  watch: {
    'form.secaoRHID.value': function (value) {
      if (value) {
        this.onGetCoordinator(value)
      }
    }
  },
  created () {
    this.onLoadAllSections()
  },
  methods: {
    ...mapActions(
      {
        signOut: authActions.SIGN_OUT
      }
    ),
    onLoad () {},
    onLoadTerm (obj) {
      this.objTerm = obj
      if (this.objTerm) {
        this.form.accept.value = 1
        this.form.accept.disabled = true
      } else {
        AcceptanceTermRepository.GetExist(this.CompanySelected, this.typeTerm.MISCELLANEOUS_EXPENSES)
          .then((response) => {
            if (response.data.code > 0 && response.data.data != null) {
              this.objTerm = response.data.data
              this.form.accept.value = 1
              this.form.accept.disabled = true
            }
            loading.close()
          })
          .catch((err) => {
            this.form.accept.value = 0
            this.form.accept.disabled = false
            this.onException(err)
          })
      }
    },
    onConfirmTerm () {
      this.$refs.confirmTerm.disabled = true
      if (this.form.accept.value > 0) {
        var self = this
        if (Tools.ValidateForms(this.form, this.data, self, toast)) {
          loading.push()
          this.data.empresaID = this.CompanySelected
          this.data.tipoTermo = this.typeTerm.MISCELLANEOUS_EXPENSES
          this.data.solicitanteID = this.userInfo.id
          this.data.dataSolicitacao = this.moment().format('YYYY-MM-DDThh:mm:ss')
          console.log(this.data)
          AcceptanceTermRepository.Create(this.data)
            .then((response) => {
              if (response.data.code > 0) {
                toast.success('Aguardar aprovação para realizar os lançamentos das despesas!', 'AUTORIZAÇÃO ENVIADA COM SUCESSO')
                console.log(response.data.data)
              } else {
                this.form.accept.value = 0
                this.form.accept.disabled = false
                toast.warning('Não foi possível processsar sua solicitação! Por favor, tente novamente mais tarde.', 'AUTORIZAÇÃO NÃO REALIZADA')
              }
              loading.close()
            })
            .catch((err) => {
              this.form.accept.value = 0
              this.form.accept.disabled = false
              this.onException(err)
              loading.close()
            })
        }
      }
    },
    onLoadAllSections () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then((response) => {
          if (response.data.code > 0) {
            this.form.secaoRHID.options = this.onResultDropdown(response, null, f => f.codigo + ' - ' + f.nome)
          }
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onClearSection () {
      this.form.secaoRH.value = ''
    },
    onChangeCodeSection (value) {
      var options = this.form.secaoRHID.options
      this.form.secaoRHID.value = ''
      for (var i in options) {
        var names = options[i].text.split('-')
        if (names[0].trim().toUpperCase() === value.toUpperCase()) {
          this.form.secaoRHID.value = options[i].value
        }
      }
    },
    onGetCoordinator (coordinateID) {
      if (coordinateID) {
        console.log(coordinateID)
        loading.push()
        CoordinatorRepository.GetByRegional(coordinateID)
          .then((response) => {
            if (response.data.code > 0) {
              if (response.data.data == null) {
                toast.warning('<br> A Regional informada não possui um Coordenador definido! <br><br> Informe ao TI para realizar o cadastro, por favor', 'DESPESAS DIVERSOS')
                this.form.secaoRH.value = ''
                this.form.secaoRHID.value = null
              }
            }
            loading.close()
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onGetEmployee () {
      // console.log(this.$refs.favorecidoTypeahead)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/miscellaneous/term/consentterm.vue